import { render } from "./CardMetric.vue?vue&type=template&id=947e9546&scoped=true"
import script from "./CardMetric.vue?vue&type=script&lang=js"
export * from "./CardMetric.vue?vue&type=script&lang=js"

import "./CardMetric.vue?vue&type=style&index=0&id=947e9546&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-947e9546"]])

export default __exports__